@if (authorizations && authorizations.length > 0) {
<ppl-accordion [title]="'My Spending Plan'" [isOpen]="true"
    *authorize="[pageId, tabId, 'SpendingPlan', 'section']">
    <ppl-spending-plan [selectedParticipantId]="selectedLead" [authorizations]="authorizations"
        [spentCurrentMonth]="spentCurrentMonth"
        (filtersChange)="onFiltersChange($event)"
        (hasAllocationChange)="onHasAllocationChange($event)"></ppl-spending-plan>
    <!-- No allocation for the selected filters means there is no breakdown to show. -->
    @if (hasAllocation) {
    <ppl-monthly-spending-plan-summary [selectedParticipantId]="selectedLead"
        [clientAuthNumber]="spendingPlanFilters?.clientAuthNumber ?? null"
        [providerId]="spendingPlanFilters?.providerId ?? null"
        [code]="spendingPlanFilters?.code ?? null"
        [servicegroupLkp]="spendingPlanFilters?.servicegroupLkp ?? null"
        [fromDate]="spendingPlanFilters?.fromDate ?? null"
        [toDate]="spendingPlanFilters?.toDate ?? null"
        (spentCurrentMonthChange)="spentCurrentMonth = $event"></ppl-monthly-spending-plan-summary>
    }
</ppl-accordion>
}

<ppl-accordion [title]="'Approved Authorizations'" [isOpen]="true" *authorize="[pageId, tabId, 'Authorization', 'section']">
    @if(this.entry === 'participantEnrollment'){
    <div class="table-style">
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="approvedData"
            [disableSelection]="true" [cols]="approvedCols" (gridAction)="action($event)" [gridTitle]="false"
            [pagination]="true" [loadPage]="false" [actionButtons]="actionButtonsApproved">
        </ppl-list-table>
    </div>
    }@else {
    <ul class="paystub-list">
        <li class="paystub-item">
            <div>
                <div class="paystub-date">September 20, 2024</div>
                <div class="paystub-amount">$1,200.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">August 20, 2024</div>
                <div class="paystub-amount">$1,150.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">July 20, 2024</div>
                <div class="paystub-amount">$1,175.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">June 20, 2024</div>
                <div class="paystub-amount">$1,125.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
    </ul>
    }
</ppl-accordion>
@if(erroredOutData?.length > 0){
<ppl-accordion [title]="'Errored Out Authorizations'" [isOpen]="true" *authorize="[pageId, tabId, 'Authorization', 'section']">

    @if(this.entry === 'participantEnrollment'){
    <div class="table-style">
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="isSectionEditable" [data]="erroredOutData"
            [disableSelection]="true" [cols]="erroredCols" (gridAction)="action($event)" [gridTitle]="false"
            [pagination]="true" [loadPage]="false" [actionButtons]="actionButtonsErrored">
        </ppl-list-table>
    </div>
    }@else {
    <ul class="paystub-list">
        <li class="paystub-item">
            <div>
                <div class="paystub-date">September 20, 2024</div>
                <div class="paystub-amount">$1,200.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">August 20, 2024</div>
                <div class="paystub-amount">$1,150.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">July 20, 2024</div>
                <div class="paystub-amount">$1,175.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
        <li class="paystub-item">
            <div>
                <div class="paystub-date">June 20, 2024</div>
                <div class="paystub-amount">$1,125.00</div>
            </div>
            <div>
                <button class="download-btn">Download PDF</button>
            </div>
        </li>
    </ul>
    }
</ppl-accordion>
}
<div class="filter-panel">
    <ng-template #authDialog let-cancel="cancel">
       <ppl-authorization-details [authorizationId]="selectedAuthorizationId" [pageSource]="pageSource" [isReadOnly]="true"></ppl-authorization-details>
    </ng-template>
</div>